import { render } from "./app.vue?vue&type=template&id=fcda92fc&scoped=true&ts=true"
import script from "./app.ts?vue&type=script&lang=ts"
export * from "./app.ts?vue&type=script&lang=ts"

import "./app.scss?vue&type=style&index=0&id=fcda92fc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src397822955/src/codestar-connections.eu-west-1.amazonaws.com/git-http/637423592620/eu-west-1/d1c24b47-9e0d-4a51-af9e-d1114251523b/studyportals/WishlistButton/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcda92fc"]])

export default __exports__